import ShUserAvatar from '@/components/Helpers/ShUserAvatar';
import ShButton from '@/components/Helpers/ShButton';
import ShDividerLine from '@/components/Helpers/ShDividerLine';
import AccountSettingsMenu from './AccountSettingsMenu';
import UserData from './UserData';

// @vue/component
export default {
  name: 'TheControlsAndAccountSettings',

  components: {
    ShUserAvatar,
    ShButton,
    ShDividerLine,
    AccountSettingsMenu,
    UserData,
  },

  props: {
    user: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      settingMenuIsVisible: false,
    };
  },

  methods: {
    goToUserProfile() {
      this.$EventBus.$emit('SHOW_USER_PROFILE', { user: this.user, shouldRefreshList: false });
    },
    handleSetMenuIsVisible() {
      this.settingMenuIsVisible = !this.settingMenuIsVisibleS;
    },
  },
};
